module.exports = __webpack_public_path__ + "static/media/romanian_pzl37.09e87e8e.png";